import { generateOperationId } from "@dataspecer/core/operation";
import { VISUAL_DIAGRAM_NODE_TYPE, VISUAL_GROUP_TYPE, VISUAL_NODE_TYPE, VISUAL_PROFILE_RELATIONSHIP_TYPE, VISUAL_RELATIONSHIP_TYPE, } from "./concepts/index.js";
import { generateEntityId } from "@dataspecer/core/entity-model";
/**
 * @see {@link AddVisualNodeOperation}
 */
export const AddVisualNodeOperationType = "https://schemas.dataspecer.com/visual-model/operations/create-visual-node";
export function createAddVisualNodeOperation(entity) {
    const entityId = entity.id ?? generateEntityId();
    return {
        id: generateOperationId(),
        type: AddVisualNodeOperationType,
        entity: { type: [VISUAL_NODE_TYPE], ...entity, id: entityId },
    };
}
export function isAddVisualNodeOperation(operation) {
    return operation.type === AddVisualNodeOperationType;
}
/**
 * @see {@link AddVisualDiagramNodeOperation}
 */
export const AddVisualDiagramNodeOperationType = "https://schemas.dataspecer.com/visual-model/operations/create-visual-diagram-node";
export function createAddVisualDiagramNodeOperation(entity) {
    const entityId = entity.id ?? generateEntityId();
    return {
        id: generateOperationId(),
        type: AddVisualDiagramNodeOperationType,
        entity: { type: [VISUAL_DIAGRAM_NODE_TYPE], ...entity, id: entityId },
    };
}
export function isAddVisualDiagramNodeOperation(operation) {
    return operation.type === AddVisualDiagramNodeOperationType;
}
/**
 * @see {@link AddVisualRelationshipOperation}
 */
export const AddVisualRelationshipOperationType = "https://schemas.dataspecer.com/visual-model/operations/create-visual-relationship";
export function createAddVisualRelationshipOperation(entity) {
    const entityId = entity.id ?? generateEntityId();
    return {
        id: generateOperationId(),
        type: AddVisualRelationshipOperationType,
        entity: { type: [VISUAL_RELATIONSHIP_TYPE], ...entity, id: entityId },
    };
}
export function isAddVisualRelationshipOperation(operation) {
    return operation.type === AddVisualRelationshipOperationType;
}
/**
 * @see {@link AddVisualProfileRelationshipOperation}
 */
export const AddVisualProfileRelationshipOperationType = "https://schemas.dataspecer.com/visual-model/operations/create-visual-profile-relationship";
export function createAddVisualProfileRelationshipOperation(entity) {
    const entityId = entity.id ?? generateEntityId();
    return {
        id: generateOperationId(),
        type: AddVisualProfileRelationshipOperationType,
        entity: { type: [VISUAL_PROFILE_RELATIONSHIP_TYPE], ...entity, id: entityId },
    };
}
export function isAddVisualProfileRelationshipOperation(operation) {
    return operation.type === AddVisualProfileRelationshipOperationType;
}
/**
 * @see {@link AddVisualGroupOperation}
 */
export const AddVisualGroupOperationType = "https://schemas.dataspecer.com/visual-model/operations/create-visual-group";
export function createAddVisualGroupOperation(entity) {
    const entityId = entity.id ?? generateEntityId();
    return {
        id: generateOperationId(),
        type: AddVisualGroupOperationType,
        entity: { type: [VISUAL_GROUP_TYPE], ...entity, id: entityId },
    };
}
export function isAddVisualGroupOperation(operation) {
    return operation.type === AddVisualGroupOperationType;
}
/**
 * @see {@link UpdateVisualEntityOperation}
 */
export const UpdateVisualEntityOperationType = "https://schemas.dataspecer.com/visual-model/operations/update-visual-entity";
export function createUpdateVisualEntityOperation(entityId, updates) {
    return {
        id: generateOperationId(),
        type: UpdateVisualEntityOperationType,
        entityId,
        updates,
    };
}
export function isUpdateVisualEntityOperation(operation) {
    return operation.type === UpdateVisualEntityOperationType;
}
/**
 * @see {@link DeleteVisualEntityOperation}
 */
export const DeleteVisualEntityOperationType = "https://schemas.dataspecer.com/visual-model/operations/delete-visual-entity";
export function createDeleteVisualEntityOperation(entityId) {
    return {
        id: generateOperationId(),
        type: DeleteVisualEntityOperationType,
        entityId,
    };
}
export function isDeleteVisualEntityOperation(operation) {
    return operation.type === DeleteVisualEntityOperationType;
}
/**
 * @see {@link SetModelColorOperation}
 */
export const SetModelColorOperationType = "https://schemas.dataspecer.com/visual-model/operations/set-model-color";
export function createSetModelColorOperation(forModelId, color) {
    return {
        id: generateOperationId(),
        type: SetModelColorOperationType,
        modelId: forModelId,
        color,
    };
}
export function isSetModelColorOperation(operation) {
    return operation.type === SetModelColorOperationType;
}
/**
 * @see {@link DeleteModelColorOperation}
 */
export const DeleteModelColorOperationType = "https://schemas.dataspecer.com/visual-model/operations/delete-model-color";
export function createDeleteModelColorOperation(modelId) {
    return {
        id: generateOperationId(),
        type: DeleteModelColorOperationType,
        modelId,
    };
}
export function isDeleteModelColorOperation(operation) {
    return operation.type === DeleteModelColorOperationType;
}
/**
 * @see {@link SetLabelOperation}
 */
export const SetLabelOperationType = "https://schemas.dataspecer.com/visual-model/operations/set-label";
export function createSetLabelOperation(label) {
    return {
        id: generateOperationId(),
        type: SetLabelOperationType,
        label,
    };
}
export function isSetLabelOperation(operation) {
    return operation.type === SetLabelOperationType;
}
/**
 * @see {@link SetViewOperation}
 */
export const SetViewOperationType = "https://schemas.dataspecer.com/visual-model/operations/set-view";
export function createSetViewOperation(view) {
    return {
        id: generateOperationId(),
        type: SetViewOperationType,
        view,
    };
}
export function isSetViewOperation(operation) {
    return operation.type === SetViewOperationType;
}
//# sourceMappingURL=operations.js.map